import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../state/store";
import {logoutAPI} from "../../services/AuthService"
import { useNavigate } from "react-router-dom";
import { AppRoutes } from "../../types/constants.types";

export default function LogoutPage() {
    const {isAuthenticated, isReady, email} = useSelector((state:RootState) => state.auth);
    const dispatch = useDispatch<AppDispatch>();
    const navigate = useNavigate()
    
	useEffect(() => {
        if(isAuthenticated){
            dispatch(logoutAPI(email)).then((resp)=>{
                navigate(AppRoutes.LOGIN);
            }).catch(err =>{
                console.log({error:err});
                navigate(AppRoutes.LOGIN);    
            })
        }
    }, []);
	return <></>;
}
